import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// Departments के नाम और उनके स्टाफ डाटा को यहां रखा है
const departments = [
    {
        name: "शैक्षणिक  स्टाफ",
        staff: [
            { id: 1, name: "डॉ. जगत नारायण", position: "सह-आचार्य", email: "jagatkuk@gmail.com" },
            { id: 2, name: "डॉ. सुरेन्द्र पाल", position: "सह-आचार्य", email: "surendervats1974@gmail.com" },
            { id: 3, name: "डॉ. रामानन्द मिश्र", position: "सहायक आचार्य", email: "ramachd91@gmail.com" },
            { id: 4, name: "डॉ. नरेश शर्मा", position: "सहायक आचार्य", email: "nareshdutt82@gmail.com" },
            { id: 5, name: "डॉ. अखिलेश कुमार मिश्र", position: "सहायक आचार्य", email: "akhimishra111@gmail.com" },
            { id: 6, name: "डॉ. कृष्ण चन्द्र पाण्डेय", position: "सहायक आचार्य", email: "krishnapandey1967@gmail.com" },
            { id: 7, name: "डॉ. शर्मिला", position: "सहायक आचार्य", email: "omsharmila88@gmail.com" },
            { id: 8, name: "डॉ. नवीन शर्मा", position: "सहायक आचार्य (अनुबंध)", email: "astronaveen1983@gmail.com" },
            { id: 9, name: "डॉ. विनय गोपाल त्रिपाठी", position: "सहायक आचार्य (अनुबंध)", email: "hncgoa89@gmail.com" },
            { id: 10, name: "डॉ. चन्द्रकांत", position: "सहायक आचार्य (अनुबंध)", email: "mr.cksharma@gmail.com" },
            { id: 11, name: "डॉ. हरीश कुमार", position: "सहायक आचार्य (अनुबंध)", email: "rishibhawan@gmail.com" },
            { id: 12, name: "डॉ. देवेन्द्र सिंह", position: "सहायक आचार्य (अनुबंध)", email: "devender.banger85@gmail.com" },
            { id: 13, name: "डॉ. कुलदीप सिंह", position: "सहायक आचार्य (अनुबंध)", email: "drkuldeepsingh934@gmail.com" },
            { id: 14, name: "डॉ. गोविन्द वल्लभ", position: "सहायक आचार्य (अनुबंध)", email: "gballabh92k@gmail.com" },
        ],
    },
    {
        name: "गैर-शैक्षणिक  स्टाफ",
        staff: [
            { id: 1, name: "डॉ. जगत नारायण", position: "उपकुलसचिव (अतिरिक्त कार्यभार)", email: "deputyregistrar@mvsu.ac.in" },
            { id: 2, name: "श्री सुभाष चन्द", position: "अधीक्षक", email: "subhashgillgju@gmail.com" },
            { id: 3, name: "श्री अंकुर गुप्ता", position: "अधीक्षक (प्रतिनियुक्ति)", email: "ankurgupta2222@gmail.com" },
            { id: 4, name: "श्री संजीव कुमार", position: "अधीक्षक (प्रतिनियुक्ति) अधीक्षक (परीक्षा शाखा, पंजीकरण शाखा एवं HRMS )", email: "Sobindlish999@gmail.com" },
            { id: 5, name: "श्री विकास कटारिया", position: "सहायक (प्रतिनियुक्ति)", email: "katatiavikas784@gmail.com" },
            { id: 6, name: "श्री इन्द्रजीत", position: "सहायक (प्रतिनियुक्ति)", email: "inderjeetgju@gmail.com" },
            { id: 7, name: "श्री प्रवीन कुमार", position: "सहायक (प्रतिनियुक्ति)", email: "pkror89@gmail.com" },
            { id: 8, name: "श्रीमती संगीता", position: "लिपिक (प्रतिनियुक्ति)", email: "riya.gill90@gmail.com" },
            { id: 9, name: "श्री चिराग", position: "स्टेनों (टाईपिस्ट)", email: "chiragsingla7575@gmail.com" },
            { id: 10, name: "श्री सुनील शर्मा", position: "कनिष्ठ अभियन्ता (Civil)", email: "sunilsharmajaswas@gmail.com" },
            { id: 11, name: "श्री देवव्रत", position: "लिपिक (HKRN)", email: "dev24koshal@gmail.com" },
            { id: 12, name: "श्री अरूण दत्त", position: "लिपिक (HKRN)", email: "arundatt87@gmail.com" },
            { id: 13, name: "श्री विनय", position: "लिपिक (HKRN)", email: "vineyattry97@gmail.com" },
            { id: 14, name: "श्री रमेश चन्द्र", position: "लिपिक (HKRN)", email: "parasharramesh095@gmail.com" },
            { id: 15, name: "श्री सीता राम", position: "लिपिक (HKRN)", email: "sitaramsharma385@gmail.com" },
            { id: 16, name: "श्रीमती स्वीटी", position: "लिपिक (HKRN)", email: "sweetysardana1981@gmail.com" },
            { id: 17, name: "श्री मुकेश कुमार", position: "लिपिक (HKRN)", email: "mukeshkaushik680@gmail.com" },
            { id: 18, name: "श्री अजय कुमार", position: "लिपिक (HKRN)", email: "ajay.keorak143@gmail.com" },
            { id: 19, name: "श्रीमती स्वीटी", position: "लिपिक (HKRN)", email: "sweetykaushik274@gmail.com" },
            { id: 20, name: "श्री कुलवन्त सिंह", position: "लिपिक (HKRN)", email: "ks6979333@gmail.com" },
            { id: 21, name: "श्री दीपक शर्मा", position: "लिपिक (HKRN)", email: "aacharyadeep1990@gmail.com" },
            { id: 22, name: "श्री महावीर", position: "लिपिक (HKRN)", email: "dr.mahavir1981@gmail.com" },
            { id: 23, name: "श्री जयबीर सिंह", position: "डी. ई. ओ. (HKRN)", email: "javeerkumar16796@gmail.com" },
            { id: 24, name: "श्रीमती मीना रानी", position: "डी. ई. ओ. (HKRN)", email: "meenaranikurar@gmail.com" },
            { id: 25, name: "श्रीमती अनिता", position: "डी. ई. ओ. (HKRN)", email: "wadhwaanitaa@gmail.com" },
            { id: 26, name: "श्रीमती आरती शर्मा", position: "डी. ई. ओ. (HKRN)", email: "artiyashu82@gmail.com" },
            { id: 27, name: "श्रीमती सविता रानी", position: "डी. ई. ओ. (HKRN)", email: "savita446@gmail.com" },
            { id: 28, name: "श्रीमती स्वाती सिंह", position: "डी. ई. ओ. (HKRN)", email: "swatisahrawat408@gmail.com" },
            { id: 29, name: "श्रीमती मंजू रानी", position: "डी. ई. ओ. (HKRN)", email: "manjuudhull@gmail.com" },
            { id: 30, name: "श्रीमती निर्मला देवी", position: "डी. ई. ओ. (HKRN)", email: "mannumannu48264@gmail.com" },
            { id: 31, name: "श्री संजीव कुमार", position: "डी. ई. ओ. (HKRN)", email: "keoraksanju@gmail.com" },
            { id: 32, name: "श्री साहिल शर्मा", position: "डी. ई. ओ. (HKRN)", email: "drsahilbhardwaj0@gmail.com" },
            { id: 33, name: "श्री सिकन्दर लाल", position: "डी. ई. ओ. (HKRN)", email: "lalsikander123@gmail.com" },
            { id: 34, name: "श्री दीपक", position: "डी. ई. ओ. (HKRN)", email: "deepakbhardwaj2455@gmail.com" },
            { id: 35, name: "श्री अंकुर", position: "डी. ई. ओ. (HKRN)", email: "asbairagiofficial@gmail.com" },
            { id: 36, name: "श्री राकेश कुमार", position: "डी. ई. ओ. (HKRN)", email: "rakeshkeorak03@gmail.com" },
            { id: 37, name: "श्री तरसेम कुमार", position: "डी. ई. ओ. (HKRN)", email: "tarsemडी. ई. ओ.ra772@gmail.com" },
            { id: 38, name: "श्री अमरदीप शर्मा", position: "डी. ई. ओ. (HKRN)", email: "amardeepsharma1008@gmail.com" },
            { id: 39, name: "श्रीमती मीनू शर्मा", position: "डी. ई. ओ. (HKRN)", email: "amardeep.bs4@gmail.com" },
        ],
    },
];

export default function StaffDirectory() {
    const [showSidebar, setShowSidebar] = useState(true);

    // डिफ़ॉल्ट में पहले विभाग को चुना हुआ दिखाएं
    const [selectedDeptIndex, setSelectedDeptIndex] = useState(0);

    const selectedDept = departments[selectedDeptIndex];

    // विभाग चुनने पर index update करें और sidebar बंद करें (small screen पर)
    const handleItemClick = (index) => {
        setSelectedDeptIndex(index);
        setShowSidebar(false);
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`text-dark p-3 shadow-lg d-flex flex-column  ${showSidebar ? "d-block" : "d-none d-md-flex"
                    } col-md-3`}
                style={{ minHeight: "100vh" }}
            >
                <h5 className="text-center fw-bold mb-3">स्टाफ डायरेक्ट्री</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            className={`mb-2 p-2 rounded shadow-sm small ${index === selectedDeptIndex
                                ? "bg-white text-primary fw-bold"
                                : "bg-light text-dark"
                                }`}
                            onClick={() => handleItemClick(index)}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9"
                onClick={() => setShowSidebar(false)}
                style={{ overflowY: "auto", maxHeight: "100vh" }}
            >
                <h5>{selectedDept.name}</h5>
                <table className="table table-bordered table-striped mt-3">
                    <thead className="table-primary">
                        <tr>
                            <th>क्र. सं.</th>
                            <th>प्राध्यापक/कर्मचारी का नाम</th>
                            <th>पद</th>
                            <th>आधिकारीक ई-मेल</th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedDept.staff.map(({ id, name, position, email }) => (
                            <tr key={id}>
                                <td>{id}</td>
                                <td>{name}</td>
                                <td>{position}</td>
                                <td>
                                    <a href={`mailto:${email}`} target="_blank" rel="noreferrer">
                                        {email}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </main>
        </div>
    );
}
